import React, { useEffect, lazy, Suspense } from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import AppLayout from "../layouts/app-layout";
import AuthLayout from "../layouts/auth-layout";
import AppLocale from "../lang";
import { IntlProvider } from "react-intl";
import { ConfigProvider } from "antd";
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH } from "../configs/AppConfig";
import useBodyClass from "../hooks/useBodyClass";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Loading from "../components/shared-components/Loading";

const Landing = lazy(() => import("./landing"));

export const Views = (props) => {
  const history = useHistory();
  useEffect(() => {
    const urlObj = new URL(window.location.href);
    const params = Object.fromEntries(urlObj.searchParams.entries());

    if (Object.keys(params).length > 0) {
      localStorage.setItem("paramsListData", JSON.stringify(params));
      if (params.task === "approve" && localStorage.getItem("token")) {
        history.push("/auth/approve-instance");
      }
    }
  }, [history]);

  const { locale, location, direction } = props;
  const currentAppLocale = AppLocale[locale];
  useBodyClass(`dir-${direction}`);

  return (
    <IntlProvider
      locale={currentAppLocale.locale}
      messages={currentAppLocale.messages}
    >
      <ConfigProvider locale={currentAppLocale.antd} direction={direction}>
        <Switch>
          <Route exact path="/">
            <Suspense fallback={<Loading cover="page" />}>
              <Landing />
            </Suspense>
          </Route>

          <Route path={AUTH_PREFIX_PATH}>
            <AuthLayout direction={direction} />
          </Route>
          <Route path={APP_PREFIX_PATH}>
            <AppLayout direction={direction} location={location} />
          </Route>
        </Switch>
      </ConfigProvider>
    </IntlProvider>
  );
};

const mapStateToProps = ({ theme, auth }) => {
  const { locale, direction } = theme;
  const { token } = auth;
  return { locale, token, direction };
};

export default withRouter(connect(mapStateToProps)(Views));
